import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { GridItem } from './details/GridItem';
class GeneralDetails extends Component {

    state = {
        // value: this.props.value,
    };

    componentDidMount() {
        console.log(this.props);
    }

    render() {
        return (
            <>
                <div className='details'>
                    <Grid container spacing={3}>
                        {this.props.row.details.map((element) => (
                            <GridItem label={element.label} value={element.value} />
                        ))}
                    </Grid>
                </div>
            </>
        )
    }
}

export default GeneralDetails;